import { useState, useEffect } from 'react';
import RadioInput from 'src/Admin/components/common/radio';
import Skeleton from 'src/Admin/components/common/skeleton';

const List = ({
  rightValueForLocationDisplayID = null,
  selectChangeHandler,
  displayId = 'BlkOfBusId',
  displayLabel = 'BlkOfBusName',
  labelIdText,
  searchString,
  modalFor = 'blob',
  fetchData,
  hasDescriptionText = false,
}) => {
  const onChangeHandler = (e) => {
    selectChangeHandler(e);
    const { id } = e.target;
    const tempBlob = data?.map((blob) =>
      blob[displayId] === id
        ? { ...blob, isChecked: true }
        : { ...blob, isChecked: false },
    );
    setData(tempBlob);
  };

  const [data, setData] = useState([]);
  const [isServerError, setIsServerError] = useState(false);
  const [isNoDataError, setIsNoDataError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      if (modalFor === 'blob') {
        try {
          const resp = await fetchData();
          console.log('resp 1', resp);
          if (resp?.allBlobData?.length > 0) {
            setData(resp?.allBlobData);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setData([]);
            setIsNoDataError(true);
          }
        } catch (error) {
          console.log('error', error);
          setIsLoading(false);
          setIsServerError(true);
        }
      } else if (modalFor === 'employer') {
        try {
          const resp = await fetchData();
          if (resp?.allEmployerData?.length > 0) {
            setData(resp?.allEmployerData);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setData([]);
            setIsNoDataError(true);
          }
        } catch (error) {
          console.log('error', error);
          setIsLoading(false);
          setIsServerError(true);
        }
      } else if (modalFor === 'location') {
        try {
          const resp = await fetchData();
          if (resp?.allLocationData?.length > 0) {
            setData(resp?.allLocationData);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setData([]);
            setIsNoDataError(true);
          }
        } catch (error) {
          console.log('error', error);
          setIsLoading(false);
          setIsServerError(true);
        }
      }
    })();
  }, []);

  return (
    <div>
      <div className="reports-modal-devider" />
      <div className="blob-lists">
        {!isLoading && !(isServerError || isNoDataError) ? (
          data
            ?.filter((d) => {
              if (!searchString) return true;
              if (displayLabel !== '' && displayId !== '') {
                if (
                  d[displayLabel]
                    ?.toLowerCase()
                    ?.includes(searchString?.toLowerCase()) ||
                  d[displayId]
                    ?.toLowerCase()
                    ?.includes(searchString?.toLowerCase())
                ) {
                  return true;
                }
              }
              return;
            })
            ?.map((item, index) => (
              <div key={index}>
                <div className="py-2 blob-list-item-border" key={index}>
                  <div className="d-flex justify-content-between">
                    <div className="">
                      <RadioInput
                        onChange={onChangeHandler}
                        label={item[displayLabel]}
                        name={'Selected-Blob'}
                        value={item[displayId]}
                        id={item[displayId]}
                        checked={item?.isChecked || false}
                        className="cursor-pointer"
                      />
                    </div>
                    {labelIdText && (
                      <div className="blob-item-name-2">
                        {labelIdText}:{' '}
                        {item[rightValueForLocationDisplayID || displayId]}
                      </div>
                    )}
                  </div>
                  {hasDescriptionText && item?.LocationDescription && (
                    <div className="blob-item-desc">
                      {item?.LocationDescription}
                    </div>
                  )}
                </div>
              </div>
            ))
        ) : isServerError || isNoDataError ? (
          <div>No Records Found</div>
        ) : (
          <Skeleton count={15} height={30} />
        )}
      </div>
    </div>
  );
};

export default List;
